<template>
    <div class="wrapper-input-form mx-auto">
        <div class="card shadow-sm p-5 border-0">
            <Address class="form-section" />

            <PolicyHolderDetails class="form-section" />

            <PhysicianDetails class="form-section" />

            <DocumentUpload :documents="$formData.policyHolder.additionalDetails.documents" />

            <div v-if="familyData.length > 0" class="form-section">
                <h2 class="text-header form-section__title">
                    <span v-for="(item, index) in $root.t('step3.familyMembers')" :key="index">
                        {{ item }} <br />
                    </span>
                </h2>
                <div id="additional-family-members" class="accordion mt-3 mb-3">
                    <div v-for="(family, index) in familyData" :key="index" class="accordion-item mb-2 border">
                        <FamilyMember :family-data="family" :member-index="index" :is-collapse="isCollapse" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Address from './Address.vue'
import PolicyHolderDetails from './PolicyHolderDetails.vue'
import PhysicianDetails from './PhysicianDetails.vue'
import FamilyMember from './FamilyMember/Index.vue'
import DocumentUpload from './DocumentUpload.vue'
import baseApi from '../../api/common/baseApi'
import helper from '../../utils/helper'

export default {
    name: 'AdditionalDetails',
    components: {
        // eslint-disable-next-line vue/no-reserved-component-names
        Address,
        PolicyHolderDetails,
        PhysicianDetails,
        FamilyMember,
        DocumentUpload,
    },
    props: {
        isCollapse: {
            type: Boolean,
            require: true,
        },
    },
    data() {
        return {
            acceptFiles: '.pdf,.docx,.doc,.rtf,.bmp,.gif,.jpg,.jpeg,.png',
            familyData: this.$formData.familyMembers,
            documents: [],
        }
    },
    mounted() {
        this.getDocumentList()
    },
    methods: {
        async getDocumentList() {
            let productId = this.$formData.product.productId
            let productName = this.$quote.products.find((p) => p.productID == productId).productName || ''
            this.documents = []
            this.documents = await baseApi.get(
                `api/documents?productId=${productId}&productName=${productName}&selectedDate=${this.$formData.policyDetails.policyStartDate}`,
            )

            await this.setDefaultDocuments(this.documents)
        },

        async setDefaultDocuments(documents) {
            // Set default file upload
            let policyHolderDocuments = this.$formData.policyHolder.additionalDetails.documents || []

            // Add new docs from api to list document
            // Policy
            for (let i = 0; i < documents.length; i++) {
                if (!policyHolderDocuments.some((doc) => doc.name == documents[i].documentName)) {
                    policyHolderDocuments.push({
                        postfix: 'PolicyHolder_' + this.$formData.id,
                        name: documents[i].documentName,
                        nameTranslation: documents[i].documentNameTranslation,
                        fileName: '',
                        appliesToJustPolicyHolder: documents[i].appliesToJustPolicyHolder,
                    })
                }
            }

            if (policyHolderDocuments.length > this.documents.length) {
                policyHolderDocuments = policyHolderDocuments.filter((pDoc) =>
                    this.documents.some((doc) => doc.documentName == pDoc.name),
                )
            }

            this.$formData.policyHolder.additionalDetails.documents = policyHolderDocuments

            // Family
            this.familyData.forEach((family) => {
                let memberDocuments = family.additionalDetails.documents || []
                for (let i = 0; i < documents.length; i++) {
                    if (
                        documents[i].appliesToJustPolicyHolder == false &&
                        !memberDocuments.some((doc) => doc.name == documents[i].documentName)
                    ) {
                        memberDocuments.push({
                            postfix: 'FamilyMember_' + family.id,
                            name: documents[i].documentName,
                            nameTranslation: documents[i].nameTranslation,
                            fileName: '',
                            appliesToJustPolicyHolder: documents[i].appliesToJustPolicyHolder,
                        })
                    }
                }

                if (memberDocuments.length > this.documents.length) {
                    memberDocuments = memberDocuments.filter((pDoc) =>
                        this.documents.some((doc) => doc.documentName == pDoc.name),
                    )
                }

                family.additionalDetails.documents = memberDocuments
            })

            this.$forceUpdate()
        },
    },
}
</script>
